var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-2 text-center"},[_c('router-link',{attrs:{"to":{ name: 'auth.login' }}},[_vm._v(" "+_vm._s(_vm.$t('core.reset_password.link.to_auth_page'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }